import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T20ClickBossOnMap() {


    const text = 'But first, you need to complete your training at the local magic academy. I’ll teach you a couple of lessons.';

    return (
        <div>
            <div className={'clickBoss20Top'}></div>
            <div className={'clickBoss20Bottom'}></div>
            <div className={'clickBoss20Right'} ></div>
            <div className={'clickBoss20Left'} ></div>

            <TutorialGirl/>
            <div className='tutorialContainer tutorialBottomContainer'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{delay: 30}}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T20ClickBossOnMap;
